import React from 'react';
interface YesNoToggleProps {
  label: string;
  value: boolean | null;
  onChange: (value: boolean) => void;
  required?: boolean;
}
export function YesNoToggle({
  label,
  value,
  onChange,
  required = false
}: YesNoToggleProps) {
  return <div className="flex flex-col gap-2" data-id="element-57">
      <label className="text-sm font-medium text-gray-700" data-id="element-58">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-59">*</span>}
      </label>
      <div className="inline-flex rounded-lg border border-gray-300 overflow-hidden w-fit" data-id="element-60">
        <button type="button" onClick={() => onChange(true)} className={`px-6 py-2 text-sm font-medium transition-colors ${value === true ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`} data-id="element-61">
          Yes
        </button>
        <button type="button" onClick={() => onChange(false)} className={`px-6 py-2 text-sm font-medium transition-colors border-l border-gray-300 ${value === false ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`} data-id="element-62">
          No
        </button>
      </div>
    </div>;
}